export default __webpack_public_path__ + "static/media/Bookmark.6877b60e.svg";